export const OPENAI_YAML_FORM_SERIALIZE_DEBOUNCE_MS = 300;

export const OPENAI_YAML_TOOL_LIST_SCROLL_DELAY_MS = 100;

export const OPENAI_YAML_TOOL_LIST_SCROLL_ANIMATION_MS = 300;

export const OPENAI_YAML_TOOL_LIST_MAX_HEIGHT_CLASS = "max-h-96";
